import { GoogleGenAI } from "@google/genai";
import { Expense, Category } from "../types";

export const getFinancialAdvice = async (expenses: Expense[], categories: Category[]): Promise<string> => {
  // Access API key from process.env as per strict guidelines
  const apiKey = process.env.API_KEY;

  if (!apiKey) {
    return "API Key do Gemini não configurada ou inválida.";
  }

  let ai: GoogleGenAI;
  try {
    ai = new GoogleGenAI({ apiKey });
  } catch (e) {
    console.error("Failed to initialize Gemini AI", e);
    return "Erro ao inicializar o assistente financeiro.";
  }

  // Prepare data for the prompt
  const expenseSummary = expenses.map(e => {
    const catName = categories.find(c => c.id === e.categoryId)?.name || 'Outros';
    return `- ${e.description}: R$ ${e.amount.toFixed(2)} (${catName}, ${e.status})`;
  }).join('\n');

  const prompt = `
    Você é um assistente financeiro pessoal experiente chamado "Fiantro AI".
    Analise as seguintes despesas recentes do usuário:

    ${expenseSummary}

    Por favor, forneça:
    1. Um breve resumo da saúde financeira atual (máximo 2 frases).
    2. Identifique a categoria com maior gasto.
    3. Dê 3 dicas práticas e curtas de economia baseadas nestes dados específicos.
    
    Responda em formato Markdown, de forma amigável e direta.
  `;

  try {
    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash',
      contents: prompt,
    });
    return response.text || "Não foi possível gerar insights no momento.";
  } catch (error) {
    console.error("Erro ao consultar Gemini:", error);
    return "Ocorreu um erro ao analisar suas finanças. Tente novamente mais tarde.";
  }
};
